import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import moment from "moment";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";
import InaccessibleLink from "../shim/inaccessible-link";
import util from "../util/util";

export default function CampaignDetailPods(props) {
  return (
    <div>
      <div className="row">
        <div className="col-xs-6">
          <h4 className="page__header">Pods</h4>
        </div>
        <div className="col-xs-6">
          <p className="page__actions">
            <Link to={util.returnPodFormUrl()} className="btn btn-primary">
              <i className="fa fa-plus" aria-hidden="true"></i>
              Create New Pod
            </Link>
          </p>
        </div>
      </div>

      <hr />

      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <colgroup>
            <col style={{ width: `1%` }}></col>
            <col style={{ width: `69%` }}></col>
            <col style={{ width: `15%` }}></col>
            <col style={{ width: `15%` }}></col>
          </colgroup>
          <thead>
            <tr>
              <th>#</th>
              <th>Pod</th>
              <th>Uploaded</th>
              <th>Remove Pod</th>
            </tr>
          </thead>
          <tbody>{renderPodRows(props.pods)}</tbody>
        </table>
      </div>
    </div>
  );

  // three options (loading, zero pods, pods);
  function renderPodRows(pods = false) {
    if (pods.length === 0) {
      return (
        <tr>
          <td colSpan="4">
            <LoadingIndicatorText />
          </td>
        </tr>
      );
    } else if (pods === false) {
      return (
        <tr>
          <td>
            <strong>0</strong>
          </td>
          <td colSpan="3">{util.zeroPodsMessage}</td>
        </tr>
      );
    } else {
      return pods.map((pod, index) => {
        return (
          <tr key={index}>
            <td>
              <strong>{index + 1}</strong>
            </td>
            <td>
              <Link to={util.returnPodDetailUrl(pod.id)}>{pod.name}</Link>
            </td>
            <td>{moment(pod.created).format(util.dateFormatHumanLong)}</td>
            <td>
              <InaccessibleLink
                className="text-danger"
                onClick={() => props.onDeletePod(pod)}
              >
                <i className="fa fa-trash-o" aria-hidden="true"></i>
                Remove
              </InaccessibleLink>
            </td>
          </tr>
        );
      });
    }
  }
}

CampaignDetailPods.propTypes = {
  pods: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  onDeletePod: PropTypes.func
};
